<template>
  <div v-if="requestedDoctors!==null">
    <b-row>
      <b-col lg="5">
        <div>
          <b-tabs content-class="mt-3" lazy>
            <b-tab title="Requests" active style="padding: 0px;">
              <Widget body-class="widget-table-overflow" fill>
                <div class="table-responsive">
                  <table class="table table-lg mb-0 requests-table table-hover table-striped">
                    <thead>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Workplace</th>
                    <th>Rate</th>
                    <th>Actions</th>
                    </thead>
                    <tbody>
                    <tr v-for="requests in requestedDoctors" :key="requests.bmdc_number">
                      <td>{{ requests.name }}</td>
                      <td>{{ requests.doctortype_id }}</td>
                      <td>{{ requests.workplace }}</td>
                      <td>{{ requests.rate }}</td>
                      <td>
                        <b-button variant="outline-success" @click="viewRequestDetail(requests)"> View Request
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                    v-model="pagination_page_number"
                    :total-rows="rows"
                    :per-page="per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    align="center"
                    pills
                    @input="paginationChanged"
                ></b-pagination>
              </Widget>
            </b-tab>
            <b-tab title="Form" style="padding: 0px; height: 70vh; overflow-y: auto;">
              <widget>
                <myform></myform>
              </widget>
            </b-tab>
            <b-tab title="File" lazy style="padding: 0px;">
              <widget style="margin-bottom: 0px;">
                <CsvXlReader></CsvXlReader>
              </widget>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
      <b-col lg="7">
        <b-row>
          <b-col xs="12">
            <Widget
                title="<h5>Doctor <span class='fw-semi-bold'>List Table</span></h5>"
                bodyClass="widget-table-overflow"
                customHeader>
              <p style="margin-left: 1%">This table shows the list of<code> Doctors </code> of the admin</p>
              <!--              <b-row>-->
              <!--                <b-col>-->
              <!--                  <div>-->
              <!--                    <input type="text" id="myInput" v-model="search" placeholder="Search for Doctor...."-->
              <!--                           title="Type in a name">-->
              <!--                    <i class="fa fa-search" id="mySearchButton"></i>-->
              <!--                  </div>-->
              <!--                </b-col>-->
              <!--              </b-row>-->
              <div class="table-responsive">
                <table class="table table-lg mb-0 requests-table table-hover" id="myTable">
                  <thead>
                  <tr class="text-muted">
                    <th><span class="fw-bold">Name</span></th>
                    <th><span class="fw-bold">Type</span></th>
                    <th><span class="fw-bold">Work Place</span></th>
                    <th><span class="fw-bold">Rate</span></th>
                    <th><span class="fw-bold">Actions</span></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in doctors" :key="row.id">
                    <td>{{ row.name }}</td>
                    <td>{{ row.doctortype_id }}</td>
                    <td>{{ row.workplace }}</td>
                    <td>{{ row.rate }}</td>
                    <td>
                      <b-button variant="outline-success" @click="doctorDetails(row)"> Details</b-button>
                      <b-button class="ml-1" variant="outline-success" @click="paymentDetails(row)"> Payment</b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <b-pagination
                  v-model="doctor_table_pagination_page_number"
                  :total-rows="rows"
                  :per-page="per_page"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  align="center"
                  pills
                  @input="doctorTablePaginationChanged"
              ></b-pagination>
            </Widget>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal ref="view-request" centered title="Ekhoni Daktar">
      <b-col v-if="pendindDoctorRequestform!==null">

        <span><b>Name:</b> {{ pendindDoctorRequestform.name }}</span> <br>
        <span><b>Mobile:</b> {{ pendindDoctorRequestform.user.mobile }}</span> <br>
        <span><b>Gender:</b> {{ (pendindDoctorRequestform.gender)? 'Male': 'Female' }}</span> <br>
        <span><b>Email:</b> {{ pendindDoctorRequestform.email }}</span> <br>

        <b-row>
          <b-col lg="6">
            <span><b>BMDC Number:</b> {{ pendindDoctorRequestform.bmdc_number }}</span>
          </b-col>
          <b-col lg="6">
            <span><b>Doctor Type:</b> {{ pendindDoctorRequestform.doctortype_id }} </span>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col lg="6">
            <span><b>Designation:</b> {{ pendindDoctorRequestform.designation }}</span>
          </b-col>
          <b-col lg="6">
            <span><b>Work place:</b> {{ pendindDoctorRequestform.workplace }} </span>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col>
            <b-form-group id="rate_group" span="Rate:" span-for="rate" description="Enter Rate">
              <b-form-input id="rate" v-model="pendindDoctorRequestform.rate" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="offer_rate_group" span="Offer Rate:" span-for="offer_rate"
                          description="Enter New Offer Rate">
              <b-form-input id="offer_rate" v-model="pendindDoctorRequestform.offer_rate" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col>
            <b-form-group id="report_followup_rate" span="Report Followup Rate:" span-for="report_followup_rate"
                          description="Enter Report Followup Rate">
              <b-form-input id="report_followup_rate" v-model="pendindDoctorRequestform.report_followup_rate"
                            type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="commission_group" span="Commission Percentage:" span-for="commission"
                          description="Enter Commission Percentage">
              <b-form-input id="commission" v-model="pendindDoctorRequestform.commission" type="number"></b-form-input>
            </b-form-group>
          </b-col>

        </b-row>
        <br>
        <b-row>

          <b-col>
            <b-form-group id="followup_rate_group" span="Follow up rate *:" span-for="followup_rate"
                          description="Enter Follow up rate ">
              <b-form-input id="followup_rate" v-model="activation_status_form.followup_rate" required
                            type="number"></b-form-input>
            </b-form-group>
          </b-col>


        </b-row>
        <br>
        <b-row>
          <!--          <b-col lg="6">-->
          <!--            <span>Medical College:<h4>{{ pendindDoctorRequestform.medical_colleg.name }}</h4></span>-->
          <!--          </b-col>-->
          <b-col lg="6">
            <span>Post Grad:<p>{{ pendindDoctorRequestform.postgrad }}</p></span>
          </b-col>
          <b-col>
            <span>Other traingings:<p>{{ pendindDoctorRequestform.other_trainings }}</p></span>
          </b-col>
        </b-row>

      </b-col>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click="cancel">
          CANCEL
        </b-button>
        <b-button size="sm" variant="success" @click="confirm(pendindDoctorRequestform.id)">
          CONFIRM
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="payment-modal" centered title="Ekhoni Daktar" @hide="makeSelectedDoctorNUll" @ok="makePayment">
      <b-container v-if="selected_doctor_from_doctor_table!==null">
        <h4 class="text-center">{{ selected_doctor_from_doctor_table.name }}</h4>
        <b-row>
          <b-col>
            <span>Pending Amount :<h4>{{ selected_doctor_from_doctor_table.pending_amount }}</h4></span>
          </b-col>
          <b-col>
            <!--            post_grad-->
            <b-form-group id="amount_group" span="Amount * :" span-for="amount" description="Enter Amount to be paid">
              <b-form-input id="amount" v-model="payment_form.amount" required type="number"
                            placeholder="Amount"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group id="date_group" span="Payment Date * :" span-for="date">
        <b-form-datepicker v-model="payment_form.date" name="date"></b-form-datepicker>
        </b-form-group>

        <b-form-group id="additional_info_group" span="Additional Info * :" span-for="additional_info">
          <b-form-input id="additional_info" v-model="payment_form.additional_info" required type="text"
                        placeholder="Additional Info"></b-form-input>
        </b-form-group>

      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Widget from "../../../components/admin/Widget/Widget";
import myform from "./form/Form";
import CsvXlReader from "./CsvXlReader/CsvXlReader";
import DoctorService from '@/services/admin/doctor.service'
import {Form} from "vform";
import moment from "moment";

export default {
  name: "Doctor",
  components: {
    Widget,
    myform,
    CsvXlReader,

  },
  data() {
    return {
      rows: null,
      per_page: null,
      pagination_page_number: 1,

      doctor_table_rows: null,
      doctor_table_per_page: null,
      doctor_table_pagination_page_number: 1,

      selected_doctor_from_doctor_table: null,

      requestedDoctors: null,
      doctors: null,

      search: '',
      doctorTypes: null,
      pendindDoctorRequestform: null,
      activation_status_form: new Form(
          {
            activation_status: null,
            rate: null,
            offer_rate: null,
            report_followup_rate: null,
            followup_rate: null,
            commission: null,
          }
      ),

      payment_form: new Form({
        amount: null,
        doctor_id: null,
        additional_info: '',
        date: '',
      }),

    };
  },
  computed: {
    // filteredRow: function () {
    //   return this.doctors.table.filter((row) => {
    //     for (var key in row) {
    //       if (String(row[key]).indexOf(this.search) !== -1) {
    //         return true;
    //       }
    //     }
    //     return false;
    //   });
    // }
  },
  methods: {
    paginationChanged() {
      console.log(this.pagination_page_number);
      DoctorService.fetchPaginatedDoctorRequests(this.pagination_page_number)
          .then((response) => {
            if (response.status === 200) {
              // console.log(response.data);
              this.requestedDoctors = response.data.data;
              this.rows = response.data.total;
              this.per_page = response.data.per_page;
              // console.log(this.requestedDoctors);
            }
          })

    },
    doctorTablePaginationChanged() {
      console.log(this.doctor_table_pagination_page_number);
      DoctorService.fetchPaginatedDoctorRequests(this.doctor_table_pagination_page_number)
          .then((response) => {
            if (response.status === 200) {
              this.doctors = response.data.data;
              this.doctor_table_rows = response.data.total;
              this.doctor_table_per_page = response.data.per_page;
            }
          })
    },
    confirm(id) {
      this.$refs['view-request'].hide();
      this.activation_status_form.activation_status = 1;
      this.activation_status_form.rate = this.pendindDoctorRequestform.rate;
      this.activation_status_form.offer_rate = this.pendindDoctorRequestform.offer_rate;
      this.activation_status_form.report_followup_rate = this.pendindDoctorRequestform.report_followup_rate;
      this.activation_status_form.commission = this.activation_status_form.commission / 100;
      DoctorService.approveDoctorRequest(id, this.activation_status_form)
          .then((response) => {
            if (response.status === 204) {
              this.paginationChanged();
            }
          })
    },
    cancel() {
      this.$refs['view-request'].hide();
      this.activation_status_form.activation_status = null;
    },
    viewRequestDetail(request) {
      this.$refs['view-request'].show();
      this.pendindDoctorRequestform = request;
      this.activation_status_form.activation_status = request.activation_status;
      console.log(this.activation_status_form.activation_status);
    },

    doctorDetails(doctor) {
      this.selected_doctor_from_doctor_table = doctor;
    },

    paymentDetails(doctor) {
      this.$refs['payment-modal'].show();
      this.selected_doctor_from_doctor_table = doctor;
      this.payment_form.doctor_id = doctor.id;
    },

    makePayment() {
      this.payment_form.date = moment(String(this.payment_form.date)).format("YYYY-MM-DDTHH:mm:ss.SZ");
      if (this.payment_form.amount <= this.selected_doctor_from_doctor_table.pending_amount) {
        DoctorService.makePayment(this.payment_form)
            .then((response) => {
              if (response.status === 201) {
                alert('ok');
              }
            })
      } else {
        alert('Amount must be less or equal to pending amount');
      }
    },

    makeSelectedDoctorNUll() {
      this.selected_doctor_from_doctor_table = null;
      //this.payment_form.fill();
      this.payment_form.amount = null;
      this.payment_form.doctor_id = null;
      this.payment_form.additional_info = null;
      this.payment_form.date = null;
    },
  },
  mounted() {
    DoctorService.fetchPaginatedDoctorRequests(this.pagination_page_number)
        .then((response) => {
          if (response.status === 200) {
            // console.log(response.data);
            this.requestedDoctors = response.data.data;
            this.rows = response.data.total;
            this.per_page = response.data.per_page;
            // console.log(this.requestedDoctors);
          }
        })

    DoctorService.fetchDoctorTypes()
        .then((response) => {
          if (response.status === 200) {
            this.doctorTypes = response.data;
            // console.log(this.doctorTypes);
          }
        })

    DoctorService.fetchApprovedDoctors(this.doctor_table_pagination_page_number)
        .then((response) => {
          if (response.status === 200) {
            this.doctors = response.data.data;
            this.doctor_table_rows = response.data.total;
            this.doctor_table_per_page = response.data.per_page;
          }
        })
  }

}
</script>

<style scoped>
.table-hover > tbody > tr:hover {
  background-color: antiquewhite;
}

#myInput {
  background-position: 10px 10px;
  background-repeat: no-repeat;
  width: 80%;
  font-size: 16px;
  padding: 12px 20px 12px 40px;
  border: 1px solid #ddd;
  margin-bottom: 12px;
  margin-left: 10%;
  border-radius: 15px;
  outline-color: green;
}

#mySearchButton {
  background-repeat: no-repeat;
  font-size: 16px;
  margin-bottom: 12px;
  margin-left: 1%;
}
</style>
